import React, { Component } from "react";

import ClienteService from "../../services/cliente";

import apiContext from "../../api";

import Page, { redirect } from "../../components/Layout/Page/Page";
import PageCenterContent from "../../components/Surfaces/PageCenterContent/PageCenterContent";
import ServiceItem from "../../components/Layout/ServiceItem/ServiceItem";
import PageHeaderImage from "../../components/Layout/PageHeaderImage/PageHeaderImage";

import TechnicianImage from "../../assets/illustrations/technician.png";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toastOperations } from "../../state/ducks/toast";
import { loadingOperations } from "../../state/ducks/loading";
import { moneyFormat } from "../../utils/Masks/Masks";
import {
  hasServicePrice,
  isFreeServicePrice,
} from "../../utils/servicePrice";
import CondominioService from "../../services/condominio";
import { LoadingToast } from "../../components/Feedback/Toast/Toast";
import { Button } from "@mui/material";
import { toast } from "react-toastify";

const FREE_SERVICE_MESSAGE = "Este serviço não tem custo.";

class ServicesConfirmContentComponent extends Component {
  static contextType = apiContext;

  constructor(props) {
    super(props);

    let services = [];

    if (props.location && props.location.state && props.location.state.services)
      services = props.location.state.services;

    this.state = {
      serviceRemoveId: null,
      submited: false,
      services,
      loading: false,
    };
  }

  get priceComplement() {
    if ((CondominioService.selectMany || []).length > 1) return "por endereço";
    return "";
  }

  handleSubmit = async () => {
    const {
      CPFCNPJ,
      email,
      [`nome-emit`]: nome,
      telefone,
    } = ClienteService.localEntrega;

    const selectMany = CondominioService.selectMany;
    const { [`local-entrega`]: localEntrega } =
      CondominioService.selected || {};
    const splitedName = nome.split(" ");
    const firstName = splitedName.shift();
    const lastName = splitedName.join(" ");

    this.props.showLoading();

    const updatedServices = [];

    for (const service of this.state.services) {
      let compDataList = service.complementaryData;
      if (!compDataList.length) compDataList = [compDataList];

      for (const compData of compDataList) {
        if (selectMany && selectMany.length > 0) {
          const promises = selectMany
            .filter((address) => address.idservice === service.service)
            .map((addresses) => {
              const {
                paymentMethod: complementaryPaymentMethod,
                ...compDataWithoutPaymentMethod
              } = compData;
              const isFreeService = isFreeServicePrice(addresses.price);

              return this.context.ConsigazApi.geraOcorrencia(
                "",
                addresses.idservice,
                addresses.price,
                addresses.codMotivo,
                addresses.nrAcordoComercial,
                CPFCNPJ,
                addresses["local-entrega"],
                {
                  ...compDataWithoutPaymentMethod,
                  contact: firstName,
                  lastNameDept: lastName,
                  phone: telefone,
                  email: email,
                  ...(!isFreeService && {
                    paymentMethod:
                      complementaryPaymentMethod || service.paymentMethod,
                  }),
                }
              )
                .then(({ Ocorrencia }) => {
                  service.protocol = Ocorrencia[0]["v-nr-ocorrencia"] || "";
                  service.dtprev = Ocorrencia[0]["v-dt-prev-atendimento"] || "";
                  service.linkPagtoMP = Ocorrencia[0]["linkPagtoMP"] || "";

                  updatedServices.push(service);
                  this.setState({
                    services: updatedServices,
                    submited: true,
                  });
                })
                .catch((errorDescription) =>
                  this.props.showToast("Ops!", errorDescription)
                );
            });
          await Promise.all(promises);
        } else {
          const {
            paymentMethod: complementaryPaymentMethod,
            ...compDataWithoutPaymentMethod
          } = compData;
          const isFreeService = this.isFreeService(service);

          await this.context.ConsigazApi.geraOcorrencia(
            "",
            service.service,
            service.price,
            service.codMotivo,
            service.nrAcordoComercial,
            CPFCNPJ,
            localEntrega,
            {
              ...compDataWithoutPaymentMethod,
              contact: firstName,
              lastNameDept: lastName,
              phone: telefone,
              email: email,
              ...(!isFreeService && {
                paymentMethod:
                  complementaryPaymentMethod || service.paymentMethod,
              }),
            }
          )
            .then(({ Ocorrencia }) => {
              if (Ocorrencia) {
                service.protocol = Ocorrencia[0]["v-nr-ocorrencia"] || "";
                service.dtprev = Ocorrencia[0]["v-dt-prev-atendimento"] || "";
                service.deadline = Ocorrencia[0]["v-dt-prev-atendimento"] || "";
                service.linkPagtoMP = Ocorrencia[0]["linkPagtoMP"] || "";
                if (service.deadline.length === 10) {
                  const [year, month, day] = service.deadline.split("-");
                  service.deadline = new Date(
                    parseInt(year),
                    parseInt(month) - 1,
                    parseInt(day)
                  ).toLocaleDateString();
                }
                this.setState({ submited: true });
              }
            })
            .catch((errorDescription) =>
              this.props.showToast("Ops!", errorDescription)
            );
        }
      }
    }
    this.setState({ loading: false });

    this.props.dismissLoading();
  };

  getServiceDeliveryDay(days) {
    return `${days} dias úteis`;
  }

  getServiceValue(service) {
    if (service.valor_total !== undefined) return service.valor_total;
    if (service["valor-total"] !== undefined) return service["valor-total"];
    if (
      service.service === "2;;" &&
      service.complementaryData &&
      service.complementaryData.tipoVazamento === "Interno"
    )
      return service.priceConditional;
    if (service.service === "15;;")
      return service.complementaryData && service.complementaryData.value;
    return service.price;
  }

  getServicePrice(service) {
    return moneyFormat(this.getServiceValue(service));
  }

  isFreeService(service) {
    return isFreeServicePrice(this.getServiceValue(service));
  }

  hasServiceCharge(service) {
    return hasServicePrice(this.getServiceValue(service));
  }

  render() {
    return (
      <>
        {this.props.showIllustration !== false && (
          <PageHeaderImage src={TechnicianImage} />
        )}
        <h1>
          {this.state.submited
            ? this.state.services.filter(
                (service) => service.service === "20;;"
              ).length > 0
              ? "Solicitação(ões) Contratada(s)!"
              : "Serviço(s) Contratado(s)!"
            : "Confirme a contratação"}
        </h1>
        <p>
          {this.state.submited
            ? "Anote o(s) protocolo(s):"
            : this.state.services.filter(
                (service) => service.service === "20;;"
              ).length > 0
            ? "Você está prestes a solicitar os serviços abaixo. Confirmar solicitação?"
            : "Você está prestes a contratar o(s) serviço(s) abaixo. Confirma a contratação?"}
        </p>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "stretch",
            justifyContent: "center",
          }}
        >
          {this.state.services.map((service) => {
            const isFreeService = this.isFreeService(service);

            return (
              <ServiceItem key={`service-${service.id}`} title={service.title}>
                {this.state.submited ? (
                  <>
                    {service.linkPagtoMP && !isFreeService ? (
                      <>
                        O serviço solicitado será efetuado até 3 dias úteis após
                        a confirmação do pagamento, e o prazo de atendimento
                        começará ser contado a partir da data do pagamento.
                        <br />
                        <div
                          style={{
                            marginTop: "16px",
                          }}
                        />
                        Protocolo:
                        <span
                          style={{
                            float: "right",
                            fontWeight: "bold",
                            fontSize: "16px",
                          }}
                        >
                          {service.protocol || "Não encontrado"}
                        </span>
                        <div
                          style={{
                            marginTop: "16px",
                          }}
                        />
                        <p>
                          O Link de Pagamento foi enviado para o e-mail
                          cadastrado: {ClienteService.localEntrega.email}
                        </p>
                        <>
                          <style>
                            {`
          .scroll-x-hidden {
            overflow-x: auto;          /* mantém scroll horizontal */
            -ms-overflow-style: none;  /* IE/Edge antigo */
            scrollbar-width: none;     /* Firefox */
          }

          .scroll-x-hidden::-webkit-scrollbar {
            display: none;             /* Chrome / Safari / Edge */
          }
          `}
                          </style>

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <div
                              className="scroll-x-hidden"
                              style={{
                                border: "solid 1px #c2c2c2",
                                backgroundColor: "#e9e9e9",
                                borderRadius: "80px",
                                height: "50px",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                position: "relative",
                                paddingInline: "12px",
                              }}
                            >
                              <span
                                style={{
                                  whiteSpace: "nowrap",
                                  fontWeight: "500",
                                  fontSize: "14px",
                                  position: "relative",
                                  paddingLeft: "12px",
                                  color: "#000",
                                }}
                              >
                                {service.linkPagtoMP}
                              </span>
                            </div>
                            <Button
                              variant="contained"
                              sx={{
                                height: "40px",
                                borderRadius: "100px",
                              }}
                              onClick={() => {
                                navigator.clipboard
                                  .writeText(service.linkPagtoMP)
                                  .then(() => {
                                    toast.success("Link copiado!");
                                  })
                                  .catch((err) => {
                                    console.error("Erro ao copiar:", err);
                                  });
                              }}
                            >
                              Copiar
                            </Button>
                          </div>
                        </>
                      </>
                    ) : (
                      <>
                        {service.deadline &&
                          `Serviço previsto para até o dia ${service.deadline}`}
                        <br />
                        Protocolo:
                        <span
                          style={{
                            float: "right",
                            fontWeight: "bold",
                            fontSize: "16px",
                          }}
                        >
                          {service.protocol || "Não encontrado"}
                        </span>
                        {isFreeService && (
                          <p style={{ margin: "16px 0 0" }}>
                            {FREE_SERVICE_MESSAGE}
                          </p>
                        )}
                        {this.hasServiceCharge(service) && (
                          <p style={{ margin: 0 }}>
                            O boleto será enviado para o email cadastrado após a
                            execução do serviço.
                          </p>
                        )}
                      </>
                    )}
                  </>
                ) : isFreeService ? (
                  <>{FREE_SERVICE_MESSAGE}</>
                ) : (
                  <>
                    {" "}
                    {`Valor total: ${this.getServicePrice(service)} ${
                      this.priceComplement
                    }`}
                    <br />
                    <br />
                    {/* {`Previsão de atendimento: ${service.deadline}`} */}
                    {`Previsão de atendimento: O serviço solicitado será efetuado até 3 dias úteis após a confirmação do pagamento, e o prazo de atendimento começará ser contado a partir da data do pagamento.`}
                  </>
                )}
              </ServiceItem>
            );
          })}
        </div>

        <br />

        {!(ClienteService.localEntrega || {}).isAdmLogin && (
          <div>
            <button
              className="block"
              style={{ marginTop: "1rem" }}
              onClick={
                this.state.submited
                  ? () => this.props.onFinish && this.props.onFinish()
                  : () => {
                      this.setState({ loading: true });
                      this.handleSubmit();
                    }
              }
            >
              {this.state.submited ? "OK" : "Confirmar contratação"}
            </button>
            {this.state.loading && <LoadingToast />}
          </div>
        )}
      </>
    );
  }
}

function mapDispatchToServicesConfirmContentProps(dispatch) {
  return bindActionCreators(
    {
      showToast: toastOperations.show,
      showLoading: loadingOperations.show,
      dismissLoading: loadingOperations.dismiss,
    },
    dispatch
  );
}

export const ServicesConfirmContent = connect(
  null,
  mapDispatchToServicesConfirmContentProps
)(ServicesConfirmContentComponent);

const ServicesConfirmPage = (props) => (
  <Page history={props.history}>
    <PageCenterContent style={{ width: "900px" }}>
      <ServicesConfirmContent
        history={props.history}
        location={props.location}
        onFinish={() => redirect(props, "/home")}
      />
    </PageCenterContent>
  </Page>
);

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showToast: toastOperations.show,
      showLoading: loadingOperations.show,
      dismissLoading: loadingOperations.dismiss,
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(ServicesConfirmPage);
